import React, { Component } from "react";
import { connect } from "react-redux";
import { IAuthProps, withAuth } from "../../../laco-common/auth/AuthContext";
import { IAuthActionDispatches, mapAuthDispatchToProps } from "../../../redux/actions/auth";
import { IAuthState, mapAuthStateToProps } from "../../../redux/reducers/auth";
import CMSRoleContext, { ICMSRoleContext } from "./CMSRole";
import { UserCMSRole, CMSPermission } from "../../../laco-common/base/models/user";

type CMSRoleProviderState = Omit<ICMSRoleContext, "hasPermission">;

class CMSRoleProvider extends Component<IAuthProps & IAuthState & IAuthActionDispatches, CMSRoleProviderState> {
	state = {
		userRoles: [],
		permissions: [],
	};

	async componentDidMount() {
		this.setPermissions();
	}

	componentDidUpdate(prevProps: IAuthProps, prevState: CMSRoleProviderState, snapshot) {
		if (
			prevProps.authContext?.uid !== this.props.authContext?.uid ||
			prevProps.authContext?.isAuthenticated !== this.props.authContext?.isAuthenticated ||
			prevProps.authContext?.userPayload?.profile?.cmsRoles !==
				this.props.authContext?.userPayload?.profile?.cmsRoles
		) {
			this.setPermissions();
		}
	}

	async setPermissions() {
		if (!Array.isArray(this.props.userRoles)) {
			await this.props.loadCMSRoles();
		}
		const cmsRoles: string[] = this.props.authContext?.userPayload?.profile?.cmsRoles;
		const userRoles: string[] = [];
		let permissions: string[] = [];
		if (cmsRoles?.length) {
			cmsRoles.forEach((roleName: string) => {
				const roleFound: UserCMSRole = this.props.userRoles?.find((role: UserCMSRole) => role.id === roleName);
				if (roleFound) {
					userRoles.push(roleFound.id);
					permissions = permissions.concat(roleFound.permissions);
				}
			});
		}
		console.log("setPermissions(): cmsRoles, userRoles, permissions:", cmsRoles, userRoles, permissions);
		this.setState({ permissions, userRoles });
	}

	render() {
		return (
			<CMSRoleContext.Provider
				value={{
					...this.state,
					hasPermission: (permission: CMSPermission): boolean => {
						return !permission || !!this.state.permissions.find((p: CMSPermission) => p === permission);
					},
				}}
			>
				{this.props.children}
			</CMSRoleContext.Provider>
		);
	}
}

export default connect<IAuthState, IAuthActionDispatches>(
	mapAuthStateToProps,
	mapAuthDispatchToProps
)(withAuth(CMSRoleProvider));
